<template>
  <v-container
    fill-height
    fluid
    grid-list-xl
    class="left-sidebar">
    <v-layout
      justify-center
      wrap>
        <v-flex
        md12>
        <v-card
        elevation="2"
        class="card-body">
        <v-card>
            <v-card-title>{{ $t('categories.addNewCategory')}}</v-card-title>
        </v-card>
        <v-spacer/>
            <v-form ref="addCategoryForm">
              <v-card-text>
                  <v-container grid-list-md mt-12>
                    <v-layout wrap>
                      <v-flex xs12 sm6 md3>
                        <v-text-field
                            v-model="categoryName"
                            :label="$t('categories.name')"
                            :placeholder="$t('categories.name')"
                            :error-messages="categoryNameErrors"
                          />
                      </v-flex>
                      <v-flex xs12 sm6 md3>
                        <v-select
                            v-model="products"
                            :items="getAllProducts"
                            :label="$t('categories.products')"
                            :placeholder="$t('categories.products')"
                            item-text="title"
                            item-value="id"
                            multiple
                        ></v-select>
                      </v-flex>
                      <v-flex xs12 sm6 md3>
                        <v-text-field
                            v-model="sku"
                            :label="$t('categories.sku')"
                            :placeholder="$t('categories.sku')"
                            :error-messages="skuErrors"
                          />
                      </v-flex>
                    <v-flex xs12 sm6 md3>
                        <v-text-field
                            v-model="sortBoxNo"
                            :label="$t('categories.sortBoxNo')"
                            :placeholder="$t('categories.sortBoxNo')"
                            :error-messages="sortBoxNoErrors"
                          />
                      </v-flex>
                    <v-flex xs12 sm6 md3>
                        <v-text-field
                            v-model="metaTitle"
                            :label="$t('categories.metaTitle')"
                            :placeholder="$t('categories.metaTitle')"
                          />
                      </v-flex>
                    <v-flex xs12 sm6 md9>
                        <v-text-field
                            v-model="metaDescription"
                            :label="$t('categories.metaDescription')"
                            :placeholder="$t('categories.metaDescription')"
                          />
                      </v-flex>
                    <v-flex xs12 sm6 md6>
                        <v-text-field
                            v-model="metaKeywords"
                            :label="$t('categories.metaKeywords')"
                            :placeholder="$t('categories.metaKeywords')"
                          />
                      </v-flex>
                    <v-flex xs12 sm6 md6>
                        <v-text-field
                            v-model="metaUrl"
                            :label="$t('categories.metaUrl')"
                            :placeholder="$t('categories.metaUrl')"
                          />
                      </v-flex>
                    <v-flex xs12 sm6 md6>
                        <v-text-field
                            v-model="metaImage"
                            :label="$t('categories.metaImage')"
                            :placeholder="$t('categories.metaImage')"
                          />
                      </v-flex>
                        <v-flex xs12 sm6 md2>
                            <v-checkbox
                                v-model="isActiveWeb"
                                :label="$t('categories.web')"
                            ></v-checkbox>
                      </v-flex>
                      <v-flex s12 xs12 sm6 md2>
                            <v-checkbox
                                v-model="isActiveMobile"
                                :label="$t('categories.mobile')"
                            ></v-checkbox>
                      </v-flex>
                      <v-flex xs12 sm6 md3>
                            <span>{{ $t('categories.categoryImage') }}</span>
                             <img id="categoryImage" class="image-product">
                            <input @change="setImage()" id="category-image"  type='file' accept="image/*"/><br>

                      </v-flex>
                      <v-flex xs12 sm6 md3>
                            <span>{{ $t('categories.icon') }}</span>
                            <img id="categoryIcon" class="icon-img-product">
                            <input @change="setIcon()" id="category-icon" class="" type='file' accept="image/*"/><br>
                      </v-flex>
                        <v-flex xs12 sm6 md3>
                            <v-color-picker v-model="color"
                                    mode="hexa"
                                    hide-mode-switch></v-color-picker>
                            <!-- <span>{{ showColor }}</span> -->
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        class="add-new mb-1 mt-8 mr-3" dark
                        @click="cancelCategory()">{{ $t('cancel')}}</v-btn>
                    <v-btn
                        class="add-new mb-1 mt-8 mr-3" dark

                        @click="createCategory()">{{ $t('submit')}}</v-btn>
                </v-card-actions>
            </v-form>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import {  mapGetters } from 'vuex';
  import { required, numeric } from 'vuelidate/lib/validators'
  import i18n from '../../i18n'
  export default {
      data () {
          return {
            categoryName: '',
            products: [],
            sku: '',
            sortBoxNo: '',
            metaTitle: '',
            metaDescription: '',
            metaKeywords: '',
            metaUrl: '',
            metaImage: '',
            isActiveWeb: false,
            isActiveMobile: false,
            type: 'hex',
            hex: '#FF00FF',
          }
      },
      validations: {
          categoryName: { required },
          sku: { required },
          sortBoxNo: { required, numeric }
      },
      computed: {
        ...mapGetters([
            'getAllProducts'
        ]),
        color: {
            get () {
                return this[this.type];
            },
            set (v) {
                    this[this.type] = v;
                },
        },
        showColor () {
            if (typeof this.color === 'string') return this.color

            return JSON.stringify(Object.keys(this.color).reduce((color, key) => {
                color[key] = Number(this.color[key].toFixed(2))
                return color
            }, {}), null, 2)
        },
        categoryNameErrors(){
            const errors = [];
                if (!this.$v.categoryName.$dirty) return errors;
                    !this.$v.categoryName.required && errors.push(i18n.tc('fieldRequired'));
                return errors;
        },
        skuErrors(){
            const errors = [];
                if (!this.$v.sku.$dirty) return errors;
                    !this.$v.sku.required && errors.push(i18n.tc('fieldRequired'));
                return errors;
        },
        sortBoxNoErrors(){
            const errors = [];
                if (!this.$v.sortBoxNo.$dirty) return errors;
                    !this.$v.sortBoxNo.numeric && errors.push(i18n.tc('fieldValueNumber'));
                    !this.$v.sortBoxNo.required && errors.push(i18n.tc('fieldRequired'));
                return errors;
        }
      },
      methods: {
        setImage(){
          const iconImage = document.getElementById('category-image').files[0];
          let output = document.getElementById('categoryImage');
              output.src = URL.createObjectURL(iconImage);
              document.getElementById('categoryImage').style.display = 'block'

              output.onload = function() {
                  URL.revokeObjectURL(output.src)
              }
        },
        setIcon(){
          const iconImage = document.getElementById('category-icon').files[0];
          let output = document.getElementById('categoryIcon');
              output.src = URL.createObjectURL(iconImage);
              document.getElementById('categoryIcon').style.display = 'block'

              output.onload = function() {
                  URL.revokeObjectURL(output.src)
              }
        },
        resetCategoryForm(){
            this.$refs.addCategoryForm.reset();
            this.$v.$reset();
            document.getElementById('category-image').value = '';
            document.getElementById('category-icon').value = '';
        },
        cancelCategory(){
            this.resetCategoryForm();
            this.$router.push(`/${i18n.locale}/categories`);
        },
        createCategory(){
          const categoryFile = document.getElementById('category-image').files[0],
                categoryIcon = document.getElementById('category-icon').files[0];

          let formData = new FormData();

              if (categoryFile) {
                formData.append('image', categoryFile);
              }

              if (categoryIcon) {
                formData.append('icon', categoryIcon);
              }

              formData.append('sku', this.sku);
              formData.append('position', this.sortBoxNo);
              formData.append('enable_mobile', this.isActiveMobile);
              formData.append('enable_web', this.isActiveWeb);
              formData.append('color', this.showColor);
              formData.append('translations[0][name]', this.categoryName);
              formData.append('translations[0][meta_title]', this.metaTitle);
              formData.append('translations[0][meta_description]', this.metaDescription);
              formData.append('translations[0][meta_keywords]', this.metaKeywords);
              formData.append('translations[0][meta_url]', this.metaUrl);
              formData.append('translations[0][meta_image]', this.metaImage);
              formData.append('translations[0][language_identifier]', 'sr');

              for (let i = 0; i < this.products.length; i++) {
                  formData.append('product_ids[]', this.products[i]);
              }

            if(this.$v.categoryName.$invalid || this.$v.sku.$invalid
                 || this.$v.sortBoxNo.$invalid){
                this.$v.$touch();
                return;
            }

          this.$store.dispatch('CREATE_CATEGORY', formData)
              .then(() => this.$store.dispatch('LOAD_ALL_CATEGORIES'))
              // .then(() => this.resetCategoryForm());
              // this.$router.push(`/${i18n.locale}/categories`);
        },
      },
      beforeCreate() {
          this.$store.dispatch('LOAD_ALL_PRODUCTS');
      },
      mounted() {
          this.$store.dispatch('LOAD_ALL_PRODUCTS');
      },
  }
</script>

<style lang="less">

</style>
